import dayjs from 'dayjs'
import businessDays from 'business-days-js'
import Constants from 'src/utilities/constants'

export function futureDateExcludeHolidaysAndWeekends(days, months) {
  let date = new Date() // Initializing date as dayjs() breaks businessDays(). MUST be new Date()

  // businessDays() requires addDays() which can not be set to less than 1 for some reason. Subtracting a day here to compensate
  if (days) {
    date.setTime(date.getTime() + 3600 * 1000 * 24 * (days - 1))
  }
  if (months) {
    const dateWithAddedMonths = dayjs(date).add(months, 'month').subtract(1, 'days').toDate()
    date.setTime(dateWithAddedMonths.getTime())
  }

  return dayjs(businessDays({state: 'tx', excludeHolidays: Constants.ATS.EXCLUDE_HOLIDAYS}).addDays(date, 1)).toDate()
}

export default {
  // disabledDate: (date) => {
  //   // disable weekends
  //   const dayOfWeek = date.getDay();
  //   return (dayOfWeek === 6) || (dayOfWeek === 0)
  // },
  dateRange: {
    shortcuts: [
      {
        text: 'Today',
        onClick (picker) {
          const end = new Date()
          const start = new Date()
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: 'Tomorrow',
        onClick (picker) {
          const end = new Date()
          const start = new Date()
          end.setTime(start.getTime() + 3600 * 1000 * 24)
          start.setTime(start.getTime() + 3600 * 1000 * 24)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: 'Yesterday',
        onClick(picker) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: 'Last week',
        onClick(picker) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: 'Last month',
        onClick(picker) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: 'Last 3 months',
        onClick(picker) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
          picker.$emit('pick', [start, end])
        }
      }
    ]
  },
  shortcuts: [
    {
      text: 'Today',
      onClick (picker) {
        picker.$emit('pick', new Date())
      }
    },
    {
      text: 'Tomorrow',
      onClick (picker) {
        picker.$emit('pick', futureDateExcludeHolidaysAndWeekends(1))
      }
    },
    {
      text: 'One week',
      onClick (picker) {
        picker.$emit('pick', futureDateExcludeHolidaysAndWeekends(7))
      }
    },
    {
      text: 'Two weeks',
      onClick (picker) {
        picker.$emit('pick', futureDateExcludeHolidaysAndWeekends(14))
      }
    },
    {
      text: 'One month',
      onClick (picker) {
        picker.$emit('pick', futureDateExcludeHolidaysAndWeekends(null, 1))
      }
    }
  ]
}
